// eslint-disable-next-line import/prefer-default-export
export const es = {
  common: {
    continued: 'Continuación',
    work_order: 'Orden de Trabajo',
    application: 'Aplicación',
    generated_on: 'Generado el',
    copyright: '© Derechos de Autor',
    getByDisplayText: (name: string, date: string) =>
      name ? `${date} por ${name}` : `${date}`,
    getPageNumberText: (pageNumber: number, totalPages: number) =>
      `${pageNumber} de ${totalPages}`
  },
  details: {
    title: 'Detalles',
    authorization: 'Autorización',
    target_time: 'Tiempo Objetivo',
    actual_time: 'Tiempo Real',
    start_time: 'Hora de inicio',
    start_time_short: 'Inicio',
    end_time: 'Hora de finalización',
    work_type: 'Tipo de Trabajo',
    timing_event: 'Evento de Tiempo',
    application_method: 'Método de Aplicación',
    most_restrictive: 'Más Restrictivo',
    rei_estimation: `Estimación de REI (Intervalo de Entrada Restringida)`,
    phi_estimation: `Estimación de PHI (Intervalo Previo a la Cosecha)`,
    rei_expiration: `Vencimiento REI (Intervalo de Entrada Restringida)`,
    phi_expiration: `Vencimiento PHI (Intervalo Previo a la Cosecha)`,
    equipment: 'Equipo',
    record_created: 'Registro Creado'
  },
  applicators: {
    title: 'Aplicadores',
    name: 'Nombre',
    license: 'Licencia',
    company: 'Compañía',
    expires: 'Expira',
    continued: 'Aplicadores continúan en la página siguiente'
  },
  weather: {
    title: 'Clima',
    sky_condition: 'Condición del Cielo',
    temperature: 'Temperatura',
    relative_humidity: 'Humedad Relativa',
    wind: 'Viento',
    soil_moisture: 'Humedad del Suelo',
    start: 'Inicio',
    end: 'Fin'
  },
  tags: {
    title: 'Etiquetas'
  },
  notes: {
    title: 'Notas',
    continued: 'Notas continúan en la página siguiente'
  },
  tank_information: {
    title: 'Información del Tanque',
    tank_size: 'Tamaño del Tanque',
    tank_count: 'Recuento de Tanques',
    overall_rate_per_acre: 'Tasa General por Acre',
    overall_total_product: 'Producto Total General'
  },
  products: {
    title: 'Productos',
    name: 'Nombre',
    epa_number: 'Número EPA',
    application_method: 'Método de Aplicación',
    target_pest: 'Plaga Objetivo',
    rei: 'REI',
    phi: 'PHI',
    application_area: 'Acres Aplicados',
    rate_per_acre: 'Tasa por Acre',
    rate_per_tank: 'Tasa por Tanque',
    total_product: 'Producto Total',
    continued: 'Productos continúan en la página siguiente',
    withLineBreaks: {
      name: 'Nombre',
      epa_number: `Número \n EPA`,
      application_method: `Método de \n Aplicación`,
      target_pest: `Plaga \n Objetivo`,
      rei: 'REI',
      phi: 'PHI',
      application_area: `Acres \n Aplicados`,
      rate_per_acre: 'Tasa por \n Acre',
      rate_per_tank: 'Tasa por \n Tanque',
      total_product: `Producto \n Total`
    }
  },
  properties: {
    title: 'Propiedades',
    farm: 'Granja',
    field: 'Campo',
    crop_zone: 'Zona de Cultivo',
    crop: 'Cultivo',
    center_lat_long: 'Lat/Long Central',
    applied_acreage: 'Acres Aplicados',
    actual_acres: 'Acres Reales',
    total_applied_acreage: 'Superficie Total Aplicada',
    continued: 'Propiedades continúan en la página siguiente'
  },
  signature: {
    signature: 'Firma',
    date: 'Fecha'
  },
  worker_protection: {
    title: 'Protección del Trabajador',
    signal_word: 'Palabra de advertencia (Signal word)',
    rup: 'Producto de uso restringido (RUP)',
    ppe: 'Equipo de protección personal (PPE)',
    reEntry: 'Reingreso (ReEntry)',
    continued: 'Protección del trabajador continúa en la página siguiente'
  }
};
